import { render } from "./ContentQualityPage.vue?vue&type=template&id=4edf139c&scoped=true"
import script from "./ContentQualityPage.vue?vue&type=script&lang=js"
export * from "./ContentQualityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edf139c"]])

export default __exports__